module.exports = __webpack_public_path__ + "img/supercharge-black.f3ccba0a.png";